import { render, staticRenderFns } from "./MaintenanceBanner.vue?vue&type=template&id=0d74dcac&scoped=true"
var script = {}
import style0 from "./MaintenanceBanner.vue?vue&type=style&index=0&id=0d74dcac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74dcac",
  null
  
)

export default component.exports